<template>
  <a class="modal-link mr-1" href="#/" @click="showPopup">
    <img :src="getImageSrc" :width="getImageSize" :height="getImageSize" alt="Info" />
  </a>
</template>
<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
library.add(faInfoCircle);
import Swal from 'sweetalert2'

import GoogleService from "../services/google.service";
export default {
  name: "ModalLink",
  data() {
    return {
        modalTitle: "",
        modalContent: "",
        displayModal: false
    };
  },
  umnounted() {},
  computed: {
    getImageSrc() {
      const supportedColors = ["white", "blue"];
      const iconColor = supportedColors.includes(this.imageColor) ? this.imageColor : "blue";

      return `/img/i-${iconColor}.svg`;
    },
    getImageSize() {
      if (this.imageSize == "normal") {
        return 13;
      }
      if (this.imageSize == "large") {
        return 22;
      }
      return 13;
    }
  },
  mounted() {
    this.setTitleAndContent();
  },
  methods: {
    setTitleAndContent() {
      let content = this.contentList.find((content) => content.title === this.modalId);
      if (typeof content !== 'undefined') {
        this.modalTitle = content.title;
        this.modalContent = content.contentText;
        this.displayModal = true;
      }
    },
    showPopup() {
      GoogleService.logClickEvent("Display Modal", this.modalId, 0, this);
      if (this.displayModal == true) {
        Swal.fire({
          title: '<h5 class="modal-title">'+this.modalTitle+'</h5>',
          html: this.modalContent,
          width: '45em',
          showCloseButton: true,
          showCancelButton: true,
          cancelButtonText: "Close",
          cancelButtonColor: "#2f5eb3",
          showConfirmButton: false,
          draggable: true
        })      
      }
    }
  },
  watch: {
    modalId() {
      this.displayModal = false;
      this.setTitleAndContent();
    },
    contentList: {
      handler(newVal, oldVal) {
        this.setTitleAndContent();
      },
      deep: true
    }, 
    /* remove once the vue 3 migration is over      
    contentList: function() {
        this.setTitleAndContent();
    }
        */
  },
  props: {
    modalId: {
      type: String,
      default: ""
    },
    contentList: {
      type: Array,
      default: function() {
        return [];
      }
    },  
    imageColor: {
      type: String,
      default: "blue"
    },
    imageSize: {
      type: String,
      default: "normal"
    }
  }
};
</script>
